import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';


import {CookiesPage} from './cookies.page';
import {BaseModule} from '../../modules/base/base.module';
import {RouterModule} from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        BaseModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild([{path: '', component: CookiesPage}])
    ],
    declarations: [CookiesPage]
})
export class CookiesPageModule {
}
